module.exports = __webpack_public_path__ + "img/icon-collapse-0f49a230.svg";